import { render, staticRenderFns } from "./ElAsmenysMigrisList.vue?vue&type=template&id=65d24f50&scoped=true&"
import script from "./ElAsmenysMigrisList.vue?vue&type=script&lang=js&"
export * from "./ElAsmenysMigrisList.vue?vue&type=script&lang=js&"
import style0 from "./ElAsmenysMigrisList.vue?vue&type=style&index=0&id=65d24f50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d24f50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCol,VDataTable,VRow,VTextField,VToolbar})
